import React from 'react';

export const Footer = () => (
  <div className="bg-[#004D94]">
    <div className="container mx-auto py-12 md:py-14 lg:py-[4.5rem] flex flex-col items-center text-center">
      <h2 className="text-3xl md:text-4xl mb-6 text-[#F3F4F8] font-semibold max-w-[51rem]">
        Enhance your marketing messaging, grow your business
      </h2>
      <p className="text-base text-[#F3F4F8] font-medium pb-6">
        Choose your marketing resources to deliver your message effectively. Submit your request today.
      </p>
      <a
        href="/professionals/resources/marketing-toolkit/request-toolkit"
        className="w-auto primary-white-large"
      >
        Submit request
      </a>
    </div>
  </div>
);
